import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import uuid4 from 'uuid4'
import App from './app'
import { initAnalytics, setAnalyticsNickname, trackEvent } from './analytics/client'
import { ANALYTICS_EVENTS } from './analytics/events'

// if ('serviceWorker' in navigator) {
//     const s = navigator.serviceWorker
//     const url = new URL('../service-worker.js', import.meta.url)
//     s.register(url)
// }
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(new URL('../service-worker.js', import.meta.url), { type: 'module', scope: '/' })
}

if (window.location.protocol === 'https:') {
    Sentry.init({
      dsn: "https://9334b3962c7e3140050a943c6ab52c93@o4508247366107136.ingest.us.sentry.io/4508247367221248",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/wordgrid\.io/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

let userToken = localStorage.getItem('userToken')
if (!userToken) {
    userToken = uuid4()
    localStorage.setItem('userToken', userToken)
}
let nickname = null
try {
    const rawSettings = localStorage.getItem('settings')
    if (rawSettings) {
        const parsed = JSON.parse(rawSettings)
        if (typeof parsed?.nickname === 'string' && parsed.nickname.trim()) {
            nickname = parsed.nickname.trim()
        }
    }
} catch {
    // Ignore malformed settings payloads.
}
initAnalytics({ userToken, appVersion: process.env.npm_package_version || null, nickname })
const API_BASE = process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:3003'

const APP_OPEN_TIMEOUT_MS = 1200
const waitForProfileNickname = async () => {
    const profileRequest = fetch(`${API_BASE}/users/profile?userToken=${encodeURIComponent(userToken)}`)
        .then(async (response) => (response.ok ? response.json() : null))
        .then((profile) => {
            const serverNickname = typeof profile?.nickname === 'string' ? profile.nickname.trim() : ''
            if (!serverNickname) {
                return
            }
            setAnalyticsNickname(serverNickname)
        })
        .catch(() => {})

    const timeout = new Promise((resolve) => {
        window.setTimeout(resolve, APP_OPEN_TIMEOUT_MS)
    })

    await Promise.race([profileRequest, timeout])
}

void waitForProfileNickname().finally(() => {
    trackEvent(ANALYTICS_EVENTS.APP_OPENED)
})

const container = document.getElementById('app')

ReactDOM.render(<App />, container)
